export const locale = {
    nl: {
        mixed: {
            default: "${path} is ongeldig",
            required: "${path} een verplicht veld",
            oneOf: "${path} must be one of the following values: ${values}",
            notOneOf: "${path} must not be one of the following values: ${values}"
        },
        array: {
            min: "${path} veld moet ten minste ${min} items bevatten",
            max: "${path} veld mag maximaal ${max} items bevatten",
            length: "${path} moet precies ${length} items bevatten"
        },
        boolean: {
            isValue: "${path} moet ${value} zijn"
        },
        date: {
            min: "${path} veld moet later of gelijk zijn dan ${min}",
            max: "${path} veld moet eerder of gelijk zijn dan ${max}"
        },
        number: {
            min: "${path} moet groter of gelijk zijn dan ${min}",
            max: "${path} moet minder of gelijk zijn dan ${max}",
            lessThan: "${path} moet minder zijn dan ${less}",
            moreThan: "${path} moet meer zijn dan ${more}",
            positive: "${path} moet een positief getal zijn",
            negative: "${path} moet een negatief getal zijn",
            integer: "${path} moet een geheel getal zijn"
        },
        string: {
            length: "${path} moet precies ${length} karakters zijn",
            min: "${path} moet ten minste ${min} karakters lang zijn",
            max: "${path} mag maximaal ${max} karakters lang zijn",
            matches: '${path} moet het volgende patroon overeenkomen: "${regex}"',
            email: "${path} moet een geldig e-mailadres zijn",
            url: "${path} moet een geldige URL zijn",
            uuid: "${path} moet een geldige UUID zijn",
            lowercase: "${path} mag alleen kleine letters bevatten",
            uppercase: "${path} mag alleen hoofdletters bevatten"
        }
    }
};
